<template>
 <div class="attachment-picker">
  <div v-if="attachments.length" class="attachment-list">
   <div v-for="image in attachments" :key="image.id" class="attachment">
    <img :src="previews[image.id]" :alt="image.name" /><span>{{ image.name }}</span>
    <button type="button" :disabled="disabled" :aria-label="`移除${image.name}`" @click="$emit('remove', image.id)">×</button>
   </div>
  </div>
  <label class="upload-button">＋ 图片
   <input type="file" accept="image/png,image/jpeg,image/webp" :multiple="limit > 1" :disabled="disabled" aria-label="选择模拟图片" @change="$emit('select', $event)" />
  </label>
  <small>PNG / JPG / WebP · 每张最多 5 MB · 最多 {{ limit }} 张</small>
 </div>
</template>
<script setup>
/* global defineProps, defineEmits */
defineProps({attachments: Array, previews: Object, limit: Number, disabled: Boolean})
defineEmits(['select', 'remove'])
</script>
<style scoped>
.attachment-picker{font-size:13px}.upload-button{display:inline-flex;position:relative;overflow:hidden;color:#1677d2;cursor:pointer;padding:8px 10px;border:1px solid #c5d6ea;border-radius:6px;margin:8px 10px 0 0;background:#fff}.upload-button input{position:absolute;opacity:0;inset:0;width:100%;cursor:pointer}small{color:#7b8799}.attachment-list{display:flex;flex-wrap:wrap;gap:12px;margin:8px 0}.attachment{position:relative;width:94px;padding:6px;background:white;border:1px solid #dbe4f0;border-radius:8px}.attachment img{width:100%;height:76px;object-fit:contain}.attachment span{display:block;font-size:11px;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.attachment button{position:absolute;right:-6px;top:-6px;border-radius:50%;width:22px;height:22px;padding:0;border:1px solid #c5d6ea;background:#fff;color:#334155;cursor:pointer}button:disabled{opacity:.5;cursor:not-allowed}@media(max-width:700px){small{display:block;margin-top:6px}}
</style>
